import React from "react";
import { observer } from "mobx-react";
import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

import { ExpandedOfferMenuCore } from ".";

export const ExpandedOfferMenu = observer(function ExpandedOfferMenu(props: {
	store: {
		isOfferMenuOpen: boolean;
		isEmpty: boolean;
		isLoading: boolean;
		toggleUpdateProcessing?: PrematchOfferMenuStore["toggleUpdateProcessing"];
		selectedSport: PrematchOfferMenuStore["selectedSport"];
		menu: PrematchOfferMenuStore["menu"];
		resetMenu: PrematchOfferMenuStore["resetMenu"];
		type: "PrematchOfferMenuStore" | "LiveOfferMenuStore";
	};
}) {
	if (!props.store.isOfferMenuOpen) {
		return null;
	}

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Desktop/ExpandedOfferMenu.tsx"}
		>
			<nav className="nav--tertiary">
				<ul className="nav--tertiary__menu">
					<ExpandedOfferMenuCore store={props.store} />
				</ul>
			</nav>
		</ErrorBoundaryWithPropagation>
	);
});
